import { useState, useMemo } from 'react';
import {
  getStreamLinkApi,
  ReqGetStreamLink,
  getShareDataApi,
  ReqGetShareData,
  getUserFeedDetailApi,
  ReqUserFeedDetail,
  cardDetailVo,
  HttpResponse,
  ResShareData,
  ResUserFeedData,
  getUserFeedDataApi,
  ResWxJsConfigSignature,
  getWxJsConfigSignatureApi,
  ResGetSecondShareCard,
  ReqGetSecondShareCard,
  requestGetSecondShareCardApi,
} from '@/api/appDownload';
import { preloadResult } from '@/utils/utils';

interface IStreamModel {
  queryStreamLink: (param: ReqGetStreamLink) => Promise<void>;
  streamLink: string;
}

export function useStreamLink(): IStreamModel {
  const [streamLink, setStreamLink] = useState<string>('');

  const [queryStreamLink] = useMemo(() => [async (param: ReqGetStreamLink) => {
    const data = await getStreamLinkApi(param);
    setStreamLink(data);
  }], []);

  return {
    queryStreamLink,
    streamLink,
  };
}

interface IShareDataModel {
  queryShareData: (param: ReqGetShareData) => Promise<void>;
  shareData: ResShareData | null;
  setShareData: (data: ResShareData | null) => void
}

export function useShareData(): IShareDataModel {
  const [shareData, setShareData] = useState<ResShareData | null>(null);

  const [queryShareData] = useMemo(() => [async (param: ReqGetShareData) => {
    const getShareDataPromise = preloadResult.get('getShareDataPromise');
    const data = await (getShareDataPromise || getShareDataApi(param));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    setShareData(data?.data || null);
  }], []);

  return {
    queryShareData,
    shareData,
    setShareData,
  };
}

interface IUserFeedDetailaModel {
  queryUserFeedDetail: (param: ReqUserFeedDetail) => Promise<HttpResponse<cardDetailVo>>;
  userFeedDetail: cardDetailVo | null;
}

export function useUserFeedDetail(): IUserFeedDetailaModel {
  const [userFeedDetail, setUserFeedDetail] = useState<cardDetailVo | null>(null);

  const [queryUserFeedDetail] = useMemo(() => [async (param: ReqUserFeedDetail) => {
    const getUserFeedDetailPromise = preloadResult.get('getUserFeedDetailPromise');
    const data = await (getUserFeedDetailPromise || getUserFeedDetailApi(param));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    setUserFeedDetail(data?.data || null);
    return data;
  }], []);

  return {
    queryUserFeedDetail,
    userFeedDetail,
  };
}

interface IUserFeedDataModel {
  queryUserFeedData: (param: ReqUserFeedDetail) => Promise<HttpResponse<ResUserFeedData>>;
  userFeedData: ResUserFeedData | null;
}

export function useUserFeedData(): IUserFeedDataModel {
  const [userFeedData, setUserFeedData] = useState<ResUserFeedData | null>(null);

  const [queryUserFeedData] = useMemo(() => [async (param: ReqUserFeedDetail) => {
    const getUserFeedDataPromise = preloadResult.get('getUserFeedDataPromise');
    const data = await (getUserFeedDataPromise || getUserFeedDataApi(param));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    setUserFeedData(data?.data || null);
    return data;
  }], []);

  return {
    queryUserFeedData,
    userFeedData,
  };
}

export function useWxJsConfigSignature() {
  const [wxJsConfigSignature, setWxJsConfigSignature] = useState<ResWxJsConfigSignature | null>(null);

  const [getWxJsConfigSignature] = useMemo(() => [
    async () => {
      const data = await getWxJsConfigSignatureApi({});
      setWxJsConfigSignature(data?.data || null);
      return data;
    },
  ], []);

  return {
    wxJsConfigSignature,
    getWxJsConfigSignature,
  };
}

interface SecondShareCardModel {
  querySecondShareCard: (param: ReqGetSecondShareCard) => Promise<HttpResponse<ResGetSecondShareCard>>;
  secondShareCard: ResGetSecondShareCard | null;
}

export function requestGetSecondShareCard(): SecondShareCardModel {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [secondShareCard, setSecondShareCard] = useState<ResGetSecondShareCard | null>(null);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [querySecondShareCard] = useMemo(() => [async (param: ReqGetSecondShareCard) => {
    const requestGetSecondShareCardPromise = preloadResult.get('requestGetSecondShareCardPromise');
    const data = await (requestGetSecondShareCardPromise || requestGetSecondShareCardApi(param));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    setSecondShareCard(data?.data || null);
    return data;
  }], []);

  return {
    querySecondShareCard,
    secondShareCard,
  };
}
